(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    function init(scope) {
      var inner = (scope || document).querySelector('[data-announce]');
      if (!inner || inner.dataset.annReady) return;
      var slots = inner.querySelectorAll('.m-announce__slot');
      if (slots.length < 2) return;
      inner.dataset.annReady = '1';
      var mq = window.matchMedia('(max-width: 900px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0, timer = null;
      function show(n) { slots.forEach(function (s, idx) { s.classList.toggle('is-active', idx === n); }); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function apply() {
        stop();
        if (mq.matches) {
          i = 0; show(0);
          if (!reduce) timer = setInterval(function () { i = (i + 1) % slots.length; show(i); }, 4000);
        } else {
          slots.forEach(function (s) { s.classList.remove('is-active'); }); // desktop: grid shows all
        }
      }
      apply();
      if (mq.addEventListener) { mq.addEventListener('change', apply); } else if (mq.addListener) { mq.addListener(apply); }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var ROOT = '[data-cart-root]';

    function money(cents) {
      // Same locked format as snippets/mobellia-money.liquid: "27 930 kr".
      var kr = Math.round(cents / 100);
      return String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
    }

    function root() { return document.querySelector(ROOT); }

    /* Re-render THIS section from the server instead of patching numbers in JS, so
       the fabric gate, the line totals and the subtotal all stay Liquid's answer. */
    function applySections(html) {
      var el = root();
      if (!el || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector(ROOT);
      if (!fresh) { window.location.reload(); return; }

      // A quantity change must not silently un-accept the terms.
      var old = el.querySelector('[data-terms-input]');
      var wasChecked = !!(old && old.checked);

      el.replaceWith(fresh);

      var box = fresh.querySelector('[data-terms-input]');
      if (box && wasChecked) {
        box.checked = true;
        box.dispatchEvent(new Event('change', { bubbles: true }));
      }
      init(fresh);
    }

    function change(line, quantity) {
      var el = root();
      if (el) el.classList.add('is-updating');
      var sectionId = (el && el.dataset.sectionId) || 'main';
      return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId, sections_url: '/cart' }),
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (d) {
          if (d.item_count === 0) { window.location.reload(); return; }
          if (d.sections && d.sections[sectionId]) applySections(d.sections[sectionId]);
          else window.location.reload();
        })
        .catch(function () { window.location.reload(); });
    }

    function initSteppers(scope) {
      scope.querySelectorAll('[data-cart-stepper]').forEach(function (st) {
        if (st.dataset.stepReady) return;
        st.dataset.stepReady = '1';
        var input = st.querySelector('[data-cart-qty]');
        var minus = st.querySelector('[data-cart-minus]');
        var plus = st.querySelector('[data-cart-plus]');
        var line = st.dataset.line;
        if (!input) return;
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var max = input.getAttribute('max');
        max = max === null || max === '' ? Infinity : parseInt(max, 10);
        var timer = null;

        function commit(v) {
          v = Math.max(min, Math.min(max, v || min));
          input.value = v;
          clearTimeout(timer);
          // Typing 1 -> 12 should be one request, not two.
          timer = setTimeout(function () { change(line, v); }, 250);
        }
        // Enter in a number field would otherwise submit the cart form, which then hits
        // the terms gate and asks for consent when all the shopper wanted was a quantity.
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); commit(parseInt(input.value, 10)); }
        });
        if (minus) minus.addEventListener('click', function () { commit((parseInt(input.value, 10) || min) - 1); });
        if (plus) plus.addEventListener('click', function () { commit((parseInt(input.value, 10) || min) + 1); });
        input.addEventListener('change', function () { commit(parseInt(input.value, 10)); });
      });

      scope.querySelectorAll('[data-cart-remove]').forEach(function (b) {
        if (b.dataset.rmReady) return;
        b.dataset.rmReady = '1';
        b.addEventListener('click', function () { change(b.dataset.line, 0); });
      });
    }

    function initTerms(scope) {
      scope.querySelectorAll('[data-terms]').forEach(function (box) {
        if (box.dataset.termsReady) return;
        box.dataset.termsReady = '1';
        var input = box.querySelector('[data-terms-input]');
        var err = box.querySelector('[data-terms-error]');
        var form = box.closest('form');
        var btn = form && form.querySelector('[data-terms-submit]');
        var sticky = document.querySelector('[data-cart-stickycta]');
        if (!input || !form || !btn) return;

        // Terms open in a new tab — reading them must never cost the shopper the cart.
        box.querySelectorAll('a[href]').forEach(function (a) {
          a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener');
        });

        // JS takes over validation so the message is Norwegian, not a browser bubble.
        form.setAttribute('novalidate', 'novalidate');

        function sync() {
          // Visual state only. No aria-disabled: see the comment on the button —
          // the press is what produces the explanation, so it must stay actionable.
          btn.classList.toggle('is-locked', !input.checked);
          if (sticky) sticky.classList.toggle('is-locked', !input.checked);
          if (input.checked) {
            // Timestamp on the order attribute: proof of WHEN it was accepted.
            var d = new Date(), pad = function (n) { return (n < 10 ? '0' : '') + n; };
            input.value = 'Ja – ' + d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
                          ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
            if (err) err.hidden = true;
            box.classList.remove('is-error');
          }
        }
        input.addEventListener('change', sync);

        function refuse() {
          if (err) err.hidden = false;
          box.classList.add('is-error');
          box.scrollIntoView({ block: 'center', behavior: 'smooth' });
          input.focus();
        }

        form.addEventListener('submit', function (e) {
          if (input.checked) return;
          e.preventDefault();
          refuse();
        });

        // The mobile bar lives outside the form, so it submits it explicitly.
        if (sticky && !sticky.dataset.ctaReady) {
          sticky.dataset.ctaReady = '1';
          sticky.addEventListener('click', function () {
            if (!input.checked) { refuse(); return; }
            btn.click();
          });
        }

        sync();
      });
    }

    function init(scope) {
      scope = scope || document;
      initSteppers(scope);
      initTerms(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else { init(); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  (function () {
    function initAccordion(root) {
      if (root.dataset.accReady) return;
      root.dataset.accReady = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-acc-item]'));
      items.forEach(function (item) {
        var trigger = item.querySelector('[data-acc-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var t = other.querySelector('[data-acc-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) { item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
        });
      });
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-mobellia-accordion]').forEach(initAccordion); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousels() {
      document.querySelectorAll('.m-carousel').forEach(function (root) {
        if (root.dataset.carouselReady) return;
        root.dataset.carouselReady = 'true';
        var track = root.querySelector('[data-carousel-track]');
        var prev = root.querySelector('[data-carousel-prev]');
        var next = root.querySelector('[data-carousel-next]');
        if (!track) return;
        function step() {
          var item = track.querySelector('.m-carousel__item');
          return item ? item.getBoundingClientRect().width + 20 : 388;
        }
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCarousels);
    } else { initCarousels(); }
    document.addEventListener('shopify:section:load', initCarousels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Does the desktop nav still fit next to the centred wordmark?
       Measured, not assumed: the ink edge of the last nav link against the ink edge of
       the wordmark, plus whether the document has started scrolling sideways. Anything
       tighter than SAFETY px, or any horizontal overflow, hands the nav to the drawer.
       This is what makes the header tolerant of nav growth instead of tuned to the nav
       it had on 2026-09-03. */
    var SAFETY = 16;

    function inkEdge(el, which) {
      if (!el) return null;
      var best = which === 'right' ? -Infinity : Infinity;
      (function walk(n) {
        if (n.nodeType === 1) {
          var cs = getComputedStyle(n);
          if (cs.display === 'none' || cs.visibility === 'hidden') return;
          if (n.classList && n.classList.contains('m-visually-hidden')) return;
        }
        if (n.nodeType === 3 && n.textContent.trim()) {
          var rg = document.createRange();
          rg.selectNodeContents(n);
          var b = rg.getBoundingClientRect();
          if (b.width || b.height) {
            best = which === 'right' ? Math.max(best, b.right) : Math.min(best, b.left);
          }
        }
        for (var i = 0; i < n.childNodes.length; i++) walk(n.childNodes[i]);
      })(el);
      return isFinite(best) ? best : null;
    }

    /* FAIL SAFE. This measurement removes data-nav to take the measurement, so a throw
       part-way through would leave the nav on screen — possibly overlapping — which is
       the worst of the three states. Any failure therefore ends in the drawer: the nav
       is still reachable, nothing overlaps, and the burger works. */
    function fitCheck(header) {
      if (!header) return;
      var forced = header.getAttribute('data-nav') === 'drawer';
      try {
        var nav = header.querySelector('.m-nav');
        var wm = header.querySelector('.m-header__wordmark');
        if (!nav || !wm) return;

        // Ask the question with the nav VISIBLE, otherwise we can never come back.
        if (forced) header.removeAttribute('data-nav');

        var navHidden = getComputedStyle(nav).display === 'none';
        if (navHidden) { if (forced) header.setAttribute('data-nav', 'drawer'); return; }

        var navRight = inkEdge(nav, 'right');
        var wmLeft = inkEdge(wm, 'left');
        var overflowing = document.documentElement.scrollWidth - document.documentElement.clientWidth > 1;
        var tooTight = (navRight !== null && wmLeft !== null) && (wmLeft - navRight) < SAFETY;

        if (overflowing || tooTight) header.setAttribute('data-nav', 'drawer');
        else header.removeAttribute('data-nav');
      } catch (e) {
        header.setAttribute('data-nav', 'drawer');
      }
    }

    function initFit(header) {
      if (!header || header.dataset.fitReady) return;
      header.dataset.fitReady = '1';
      var run = function () { fitCheck(header); };
      run();
      // fonts change text width after load, which is exactly when this matters
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
      window.addEventListener('resize', function () {
        clearTimeout(header._fitT);
        header._fitT = setTimeout(run, 120);
      });
      window.addEventListener('load', run);
    }

    function initHeader(header) {
      /* initFit runs first, so an exception in it used to skip everything below —
         the mega menu AND the drawer wiring, which would leave the burger dead. It is
         isolated now: the fit check is an enhancement, not a prerequisite. */
      try { initFit(header); } catch (e) { header.setAttribute('data-nav', 'drawer'); }
      if (!header || header.dataset.megaReady) return;
      header.dataset.megaReady = 'true';

      var triggers = header.querySelectorAll('[data-mega-trigger]');
      var panels = header.querySelectorAll('[data-mega-panel]');
      var closers = header.querySelectorAll('[data-mega-close]');

      function closeAll() {
        panels.forEach(function (p) { p.classList.remove('is-open'); });
        triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      }

      function open(id) {
        panels.forEach(function (p) {
          p.classList.toggle('is-open', p.getAttribute('data-mega-panel') === id);
        });
        triggers.forEach(function (t) {
          t.setAttribute('aria-expanded', t.getAttribute('data-mega-trigger') === id ? 'true' : 'false');
        });
      }

      triggers.forEach(function (t) {
        var id = t.getAttribute('data-mega-trigger');
        t.addEventListener('mouseenter', function () { open(id); });
        t.addEventListener('focus', function () { open(id); });
      });

      // Hovering the wordmark / icon cluster dismisses any open panel.
      closers.forEach(function (c) {
        c.addEventListener('mouseenter', closeAll);
      });

      header.addEventListener('mouseleave', closeAll);
      header.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeAll(); }
      });
    }

    function initDrawer() {
      var openBtn = document.querySelector('[data-drawer-open]');
      var drawer = document.querySelector('[data-drawer]');
      if (!openBtn || !drawer || drawer.dataset.drawerReady) return;
      drawer.dataset.drawerReady = 'true';

      function setOpen(isOpen) {
        drawer.classList.toggle('is-open', isOpen);
        drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        openBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.body.classList.toggle('m-no-scroll', isOpen);
      }

      openBtn.addEventListener('click', function () { setOpen(true); });
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
        el.addEventListener('click', function () { setOpen(false); });
      });
      // Close after following any link inside the drawer.
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { setOpen(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) { setOpen(false); }
      });
    }

    function initWishlist() {
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        if (btn.dataset.wishReady) return;
        btn.dataset.wishReady = 'true';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          btn.setAttribute('aria-pressed', btn.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-mobellia-header]').forEach(initHeader);
      initDrawer();
      initWishlist();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Re-init when the section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(scope) {
      (scope || document).querySelectorAll('[data-hero]').forEach(function (hero) {
        if (hero.dataset.heroReady) return;
        var slides = hero.querySelectorAll('[data-hero-slide]');
        var contents = hero.querySelectorAll('[data-hero-content]');
        var dots = hero.querySelectorAll('[data-hero-dot]');
        if (slides.length < 2) return;
        hero.dataset.heroReady = '1';
        var i = 0, n = slides.length, timer = null;
        var speed = parseInt(hero.getAttribute('data-hero-autoplay'), 10) || 0;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Slides after the first carry their URLs in data-* so the browser does not download
        // every hero photo during the initial load; attach them the first time a slide runs.
        function attach(el) {
          if (!el) return;
          var img = el.querySelector('img[data-hero-src]');
          if (!img) return;
          var ss = img.getAttribute('data-hero-srcset');
          if (ss) img.setAttribute('srcset', ss);
          img.setAttribute('src', img.getAttribute('data-hero-src'));
          img.removeAttribute('data-hero-src');
          img.removeAttribute('data-hero-srcset');
        }
        function go(to) {
          to = (to + n) % n;
          if (to === i) return;
          attach(slides[to]);
          slides[i].classList.remove('is-active');
          contents[i].classList.remove('is-active');
          if (dots[i]) dots[i].classList.remove('is-active');
          i = to;
          slides[i].classList.add('is-active');
          contents[i].classList.add('is-active');
          if (dots[i]) dots[i].classList.add('is-active');
        }
        function next() { go(i + 1); }
        var warm = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
        warm(function () { attach(slides[(i + 1) % n]); });
        function start() { stop(); if (speed && !reduce) timer = setInterval(next, speed); }
        function stop() { if (timer) { clearInterval(timer); timer = null; } }

        dots.forEach(function (d) {
          d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hero-dot'), 10)); start(); });
        });
        hero.addEventListener('mouseenter', stop);
        hero.addEventListener('mouseleave', start);

        // Touch swipe (mobile): swipe left = next, right = previous.
        var tx = 0, ty = 0, swiping = false;
        hero.addEventListener('touchstart', function (e) {
          var t = e.changedTouches[0]; tx = t.clientX; ty = t.clientY; swiping = true; stop();
        }, { passive: true });
        hero.addEventListener('touchend', function (e) {
          if (!swiping) return; swiping = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - tx, dy = t.clientY - ty;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) { go(dx < 0 ? i + 1 : i - 1); }
          start();
        }, { passive: true });

        // Desktop prev/next arrows (reuse the same go() + autoplay reset).
        var prev = hero.querySelector('[data-hero-prev]');
        var nextBtn = hero.querySelector('[data-hero-next]');
        if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
        if (nextBtn) nextBtn.addEventListener('click', function () { go(i + 1); start(); });
        // Keyboard when the hero (or a child) is focused.
        hero.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { go(i - 1); start(); }
          else if (e.key === 'ArrowRight') { go(i + 1); start(); }
        });

        start();
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initHero(); }); } else { initHero(); }
    document.addEventListener('shopify:section:load', function (e) { initHero(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    function initSort(scope) {
      (scope || document).querySelectorAll('[data-sort]').forEach(function (sel) {
        if (sel.dataset.ready) return;
        sel.dataset.ready = 'true';
        sel.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sel.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
    }

    // Infinite scroll: fetch the next page via the Section Rendering API and append cards.
    function initInfinite(scope) {
      (scope || document).querySelectorAll('[data-infinite]').forEach(function (more) {
        if (more.dataset.infReady) return;
        more.dataset.infReady = '1';
        var coll = more.closest('.m-coll') || document;
        var grid = coll.querySelector('[data-infinite-grid]');
        var sentinel = coll.querySelector('[data-infinite-sentinel]');
        var loading = more.querySelector('[data-infinite-loading]');
        var link = more.querySelector('[data-infinite-link]');
        var sectionId = more.getAttribute('data-section-id');
        var nextUrl = more.getAttribute('data-next-url') || '';
        if (!grid || !sentinel || !nextUrl) return;
        more.classList.add('is-js'); // hides the fallback button (still in DOM for SEO/no-JS)
        var busy = false, observer;

        function stop() { nextUrl = ''; if (observer) observer.disconnect(); if (loading) loading.hidden = true; }
        function load() {
          if (busy || !nextUrl) return;
          busy = true;
          if (loading) loading.hidden = false;
          var url = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
          fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
            if (!html) { stop(); busy = false; return; }
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-infinite-grid]');
            if (newGrid) {
              var frag = document.createDocumentFragment();
              while (newGrid.firstElementChild) { frag.appendChild(newGrid.firstElementChild); }
              grid.appendChild(frag);
              document.dispatchEvent(new CustomEvent('mobellia:products:appended'));
            }
            var nextMore = doc.querySelector('[data-infinite]');
            nextUrl = nextMore ? (nextMore.getAttribute('data-next-url') || '') : '';
            if (loading) loading.hidden = true;
            busy = false;
            if (!nextUrl) stop();
          }).catch(function () { if (loading) loading.hidden = true; busy = false; });
        }

        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (e.isIntersecting) load(); });
          }, { rootMargin: '700px 0px' }); // load before the user reaches the bottom
          observer.observe(sentinel);
        } else if (link) {
          // No IO support: keep the button as the load mechanism.
          more.classList.remove('is-js');
          link.addEventListener('click', function (e) { e.preventDefault(); load(); });
        }
      });
    }

    // Filter drawer (mobile bottom-sheet / desktop right drawer). Filter links
    // navigate immediately (no-JS safe); the drawer re-opens after each navigation
    // so multi-select feels continuous.
    function initFilterDrawer(scope) {
      var root = scope || document;
      var drawer = root.querySelector('[data-filter-drawer]');
      if (!drawer || drawer.dataset.fdReady) return;
      drawer.dataset.fdReady = '1';
      var KEY = 'm-filter-open';
      var openBtns = root.querySelectorAll('[data-filter-open]');
      function setExpanded(on) { openBtns.forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); }); }
      function open() {
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        // Both presentations (desktop left panel + mobile bottom sheet) are full
        // overlays, so lock page scroll while open.
        document.documentElement.style.overflow = 'hidden';
        setExpanded(true);
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      }
      function close() {
        drawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        setExpanded(false);
        try { sessionStorage.removeItem(KEY); } catch (e) {}
        setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 340);
      }
      openBtns.forEach(function (b) { b.addEventListener('click', open); });
      drawer.querySelectorAll('[data-filter-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
      try { if (sessionStorage.getItem(KEY) === '1') open(); } catch (e) {}
    }

    // Category chip-bar overflow nav (desktop). Single implementation: chevrons +
    // edge fade + wheel + drag. Chevrons are real buttons (Enter/Space native);
    // hidden on touch/mobile via CSS. No competing handler.
    function initChipNav(scope) {
      (scope || document).querySelectorAll('[data-chipnav]').forEach(function (nav) {
        if (nav.dataset.chipReady) return;
        nav.dataset.chipReady = '1';
        var track = nav.querySelector('[data-chip-scroll]');
        var prev = nav.querySelector('[data-chip-prev]');
        var next = nav.querySelector('[data-chip-next]');
        if (!track) return;
        var isTouch = window.matchMedia('(max-width: 700px)').matches || ('ontouchstart' in window);
        function update() {
          var max = track.scrollWidth - track.clientWidth;
          var canLeft = track.scrollLeft > 1;
          var canRight = track.scrollLeft < max - 1;
          nav.classList.toggle('can-left', canLeft && max > 1);
          nav.classList.toggle('can-right', canRight && max > 1);
          // Chevrons only on non-touch widths AND only when that side has overflow.
          if (prev) prev.hidden = isTouch || !(canLeft && max > 1);
          if (next) next.hidden = isTouch || !(canRight && max > 1);
        }
        function step(dir) { track.scrollBy({ left: dir * Math.max(160, track.clientWidth * 0.8), behavior: 'smooth' }); }
        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });
        track.addEventListener('scroll', update, { passive: true });
        // Vertical wheel -> horizontal scroll (desktop only).
        track.addEventListener('wheel', function (e) {
          if (isTouch) return;
          if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { track.scrollLeft += e.deltaY; e.preventDefault(); }
        }, { passive: false });
        // Click-drag to scroll.
        var down = false, startX = 0, startL = 0, moved = false;
        track.addEventListener('pointerdown', function (e) { if (isTouch) return; down = true; moved = false; startX = e.clientX; startL = track.scrollLeft; });
        window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - startX; if (Math.abs(dx) > 3) moved = true; track.scrollLeft = startL - dx; });
        window.addEventListener('pointerup', function () { down = false; setTimeout(function () { moved = false; }, 0); });
        track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
        // Bring the active chip into view.
        var active = track.querySelector('.is-selected');
        if (active) { var l = active.offsetLeft - track.clientWidth / 2 + active.offsetWidth / 2; track.scrollLeft = Math.max(0, l); }
        window.addEventListener('resize', function () { isTouch = window.matchMedia('(max-width: 700px)').matches || ('ontouchstart' in window); update(); });
        update();
      });
    }

    function init(scope) { initSort(scope); initInfinite(scope); initFilterDrawer(scope); initChipNav(scope); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function nok(cents) {
      var kr = Math.round(cents / 100);
      return kr.toLocaleString('nb-NO') + ' kr';
    }
    function initPdp(root) {
      if (!root || root.dataset.pdpReady) return;
      root.dataset.pdpReady = 'true';

      // ----- Variant selection -----
      var jsonEl = root.querySelector('[data-variant-json]');
      var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      var optionGroups = root.querySelectorAll('[data-option]');
      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-price]');
      var designerEl = root.querySelector('[data-designer-price]');
      var compareEl = root.querySelector('[data-compare]');
      var addBtn = root.querySelector('[data-add-btn]');
      var addLabel = root.querySelector('[data-add-label]');
      var buyRoot = root.querySelector('[data-buy]');
      var notifyBody = root.querySelector('[data-notify-body]');
      // 2026-11-03 owner: "Legg i handlekurv" used to leave the product for /cart (~3 s). Now it adds
      // in place and shows a small confirmation with "Gå til handlekurv". Checkout still only starts
      // on /cart, so the mandatory terms checkbox there is unchanged. Any failure falls back to the
      // normal form POST. Runs after the fabric gate (capture phase), which may already have stopped it.
      (function () {
        var form = addBtn && addBtn.form;
        if (!form || !window.fetch) return;
        var toast;
        function showToast(title) {
          if (!toast) {
            toast = document.createElement('div');
            toast.className = 'm-added'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
            toast.innerHTML = '<p class="m-added__title"></p><div class="m-added__actions"><a class="m-btn m-added__go" href="/cart">Gå til handlekurv</a><button type="button" class="m-added__stay">Fortsett å handle</button></div>';
            document.body.appendChild(toast);
            toast.querySelector('.m-added__stay').addEventListener('click', function () { toast.classList.remove('is-open'); });
          }
          toast.querySelector('.m-added__title').textContent = 'Lagt i handlekurven: ' + title;
          toast.classList.add('is-open');
          clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-open'); }, 8000);
        }
        form.addEventListener('submit', function (e) {
          if (e.defaultPrevented) return;
          var sub = e.submitter;
          if (sub && sub !== addBtn) return;
          e.preventDefault();
          addBtn.disabled = true;
          fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
            .then(function (item) {
              return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
                document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
                showToast(item.product_title || item.title || '');
              });
            })
            .catch(function () { form.submit(); })
            .then(function () { addBtn.disabled = false; });
        });
      })();
      // Back-in-stock: AJAX-post the native contact form so we can show an inline
      // confirmation without leaving the product (Shopify would otherwise redirect
      // to /contact). No-JS still works via the normal form POST. A PDP-level
      // submit listener swallows the native event, so we drive it from the click.
      (function () {
        var nWrap = root.querySelector('[data-notify]');
        var nForm = nWrap && nWrap.querySelector('form');
        var nBtn = nForm && nForm.querySelector('[type="submit"]');
        if (!nForm || !nBtn) return;
        nBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (!nForm.reportValidity()) return;
          nBtn.disabled = true;
          fetch('/contact', { method: 'POST', body: new FormData(nForm), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function () {
              var msg = nWrap.getAttribute('data-notify-msg') || 'Takk! Vi varsler deg.';
              nForm.outerHTML = '<p class="m-notify__ok">' + msg + '</p>';
            })
            .catch(function () { nForm.submit(); }); // fallback: native post
        });
      })();
      var addText = addLabel ? addLabel.textContent : 'Legg i handlekurv';
      var soldText = (addBtn && addBtn.getAttribute('data-sold')) || 'Utsolgt';
      // The variant Liquid already resolved (selected_or_first_available_variant),
      // read before any JS can overwrite the field. This is Shopify's own answer
      // and stays the source of truth for products with nothing to choose.
      var initialVariantId = idInput ? String(idInput.value || '') : '';

      function selectedValues() {
        return Array.prototype.map.call(optionGroups, function (g) {
          var checked = g.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }
      function matchVariant(vals) {
        // Products with only the default variant render no option pills at all
        // (see the `unless product.has_only_default_variant` guard above), so
        // `vals` is empty — and ["Default Title"].every(o => o === vals[0]) is
        // false because vals[0] is undefined. Without this branch the single
        // real variant looks like a phantom combination and update() disables
        // the buy button as "Utsolgt" on every such product.
        // Nothing is selectable here, so keep Shopify's server-side choice.
        // Resolved by id, never "just take variants[0]" — no guessing.
        if (!optionGroups.length) {
          return variants.filter(function (v) {
            return String(v.id) === initialVariantId;
          })[0] || null;
        }
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === vals[i]; });
        });
      }
      // Display-only value normalization (e.g. "140cmx200cm" -> "140 × 200 cm").
      function normVal(s) {
        if (!s) return s;
        return String(s)
          .replace(/(\d)\s*cm\s*[x×]\s*(\d)/gi, '$1 × $2')
          .replace(/(\d)\s*[x×]\s*(\d)/g, '$1 × $2')
          .replace(/(\d)\s*cm\b/gi, '$1 cm')
          .replace(/\s{2,}/g, ' ').trim();
      }
      // No syncPills(): the pill fill is pure CSS (.m-vpill:has(input:checked)).
      function syncSelectedLabels() {
        optionGroups.forEach(function (g) {
          var checked = g.querySelector('input:checked');
          var disp = g.querySelector('[data-opt-selected]');
          if (disp && checked) disp.textContent = normVal(checked.value);
        });
      }
      // Pill state against the current selection (QA H2, 2026-10-13). Nothing is ever made
      // unclickable: a value whose exact combination does not exist is still reachable,
      // because resolveFrom() moves the other options to the nearest available variant.
      //   is-other       — available, but not together with the current other choices
      //   is-unavailable — no available variant carries this value at all, or the exact
      //                    combination exists and is sold out
      function refreshAvailability() {
        if (!variants.length) return;
        var sel = selectedValues();
        optionGroups.forEach(function (g, gi) {
          g.querySelectorAll('[data-opt-pill]').forEach(function (lab) {
            var inp = lab.querySelector('input'); if (!inp) return;
            var val = inp.value;
            var exact = null, anyAvail = false;
            variants.forEach(function (v) {
              if (v.options[gi] !== val) return;
              if (v.available) anyAvail = true;
              if (v.options.every(function (o, i) { return i === gi || sel[i] == null || o === sel[i]; })) {
                if (!exact || (v.available && !exact.available)) exact = v;
              }
            });
            var unavailable = !anyAvail || (exact && !exact.available);
            var other = !unavailable && !exact;
            lab.classList.toggle('is-unavailable', !!unavailable);
            lab.classList.toggle('is-other', !!other);
            if (other) lab.title = 'Finnes ikke i valgt kombinasjon – velg for å bytte';
            else lab.removeAttribute('title');
          });
        });
      }
      // The shopper picked value `val` in group `gi`. If that exact combination exists, keep
      // it (even sold out — that shows Utsolgt + the back-in-stock form, as before). If it
      // does not exist, move to the nearest variant WITH that value: available first, then
      // the most other selections kept, earlier option groups weighing more (keep Stoff
      // when Farge changes). Ties keep the store's variant order. The last pick of any
      // sequence is therefore always honoured exactly, so every variant is reachable.
      function resolveFrom(gi) {
        var sel = selectedValues();
        var val = sel[gi];
        if (val == null) return;
        var exact = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        });
        if (exact) return;
        var cands = variants.filter(function (v) { return v.options[gi] === val; });
        if (!cands.length) return;
        var avail = cands.filter(function (v) { return v.available; });
        if (avail.length) cands = avail;
        var n = optionGroups.length, best = null, bestScore = -1;
        cands.forEach(function (v) {
          var score = 0;
          for (var i = 0; i < n; i++) if (i !== gi && v.options[i] === sel[i]) score += Math.pow(2, n - i);
          if (score > bestScore) { bestScore = score; best = v; }
        });
        if (best) setSelection(best.options);
      }
      function setSelection(opts) {
        optionGroups.forEach(function (g, i) {
          g.querySelectorAll('input[data-opt-input]').forEach(function (inp) { inp.checked = inp.value === opts[i]; });
        });
      }
      var galleryApi = null;
      var lastVariantId = null;
      function update(e) {
        syncSelectedLabels();
        refreshAvailability();
        if (!variants.length) return;
        // Only a real, existing variant is selectable. A non-existent (phantom)
        // combination is not addable — never fall back to another variant.
        var v = matchVariant(selectedValues());
        if (!v) {
          if (idInput) idInput.value = '';
          if (addBtn && addLabel) { addBtn.disabled = true; addLabel.textContent = soldText; }
          return;
        }
        if (idInput) idInput.value = v.id;
        // The photo follows the variant (QA H1). On load it only re-asserts what Liquid
        // already rendered for ?variant= / the first available variant.
        if (galleryApi && String(v.id) !== lastVariantId) galleryApi.showVariant(v);
        // Shareable URL for a real selection (never on load: the URL is already right).
        if (e && String(v.id) !== lastVariantId && window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            history.replaceState(history.state, '', u.toString());
          } catch (err) {}
        }
        lastVariantId = String(v.id);
        if (priceEl) priceEl.textContent = nok(v.price);
        if (designerEl) designerEl.querySelector('strong').textContent =
          nok(Math.floor(v.price * Number(designerEl.getAttribute('data-designer-factor')) / 100));
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = nok(v.compare_at_price);
            compareEl.hidden = false;
          } else { compareEl.hidden = true; }
        }
        if (addBtn && addLabel) {
          if (v.available) { addBtn.disabled = false; addLabel.textContent = addText; }
          else { addBtn.disabled = true; addLabel.textContent = soldText; }
        }
        // Back-in-stock: toggle the capture with the selected variant's availability,
        // and keep the hidden notification body pointing at the chosen variant.
        if (buyRoot) buyRoot.setAttribute('data-available', v.available ? 'true' : 'false');
        if (notifyBody && v.title) notifyBody.value = notifyBody.value.replace(/—[^.]*\./, '— ' + v.title + '.');
      }
      optionGroups.forEach(function (g, gi) {
        g.querySelectorAll('input[type="radio"]').forEach(function (inp) {
          inp.addEventListener('change', function (e) { resolveFrom(gi); update(e); });
        });
      });
      // Invariant guard: exactly ONE radio checked per group. The shared name keeps
      // it that way after clicks; on load we enforce it and self-heal + warn if a
      // render ever produced two — so the "two pills filled" bug cannot regress.
      optionGroups.forEach(function (g) {
        var checked = g.querySelectorAll('input:checked');
        if (checked.length === 0) {
          var first = g.querySelector('input'); if (first) first.checked = true;
        } else if (checked.length > 1) {
          if (window.console) console.warn('[Mobellia] variant group "' + (g.getAttribute('data-option-name') || '') + '" had ' + checked.length + ' checked (expected 1) — healing.');
          Array.prototype.slice.call(checked, 1).forEach(function (x) { x.checked = false; });
        }
      });
      // Normalize all pill labels once, then sync selected labels + availability.
      root.querySelectorAll('.m-vpill__txt').forEach(function (el) { el.textContent = normVal(el.textContent); });
      syncSelectedLabels();
      refreshAvailability();

      // ----- Fabric: 5 featured + "Se alle N" + full picker drawer (data-driven) -----
      // Selection model unchanged: clicking a [data-fabric] sets property[Stoff] +
      // the displayed name. The 5 featured are DERIVED at render from this product's
      // colours + the trend_palette priority (never a fixed list). Reuses the same
      // swatch markup in Layer 1 and the drawer so selection stays in sync.
      (function () {
        var fab = root.querySelector('[data-fab]');
        var fabricProp = root.querySelector('[data-fabric-prop]');
        var fabricName = root.querySelector('[data-fabric-name]');
        if (!fab) return;
        var featuredWrap = fab.querySelector('[data-fab-featured]');
        var fallback = fab.querySelector('[data-fab-fallback]');
        var allBtn = fab.querySelector('[data-fab-all]');
        var countEl = fab.querySelector('[data-fab-count]');
        var dataEl = root.querySelector('[data-fab-data]');
        var trendEl = root.querySelector('[data-fab-trend]');
        var drawer = root.querySelector('[data-fab-drawer]');
        var chipsWrap = drawer && drawer.querySelector('[data-fab-chips]');
        var groupsWrap = drawer && drawer.querySelector('[data-fab-groups]');
        if (!featuredWrap || !dataEl) return;
        var fabrics, trend;
        try { fabrics = JSON.parse(dataEl.textContent) || []; } catch (e) { return; }
        try { trend = JSON.parse(trendEl.textContent) || []; } catch (e) { trend = []; }
        if (!fabrics.length) return;

        // colour-family derivation from the colour word — a mapping table, not per-product.
        var FAM = [
          ['Hvit', ['hvit','white','cream','krem','ivory','elfenben','pearl','perle','snow','chalk','natural','offwhite','off-white']],
          ['Beige', ['beige','sand','greige','taupe','mushroom','oat','latte','camel','nougat','hazel','lin ','linen','stone','steingr']],
          ['Brun', ['brun','brown','chocolate','sjokolade','cognac','konjakk','mocha','mokka','coffee','kaffe','walnut','valn','cappuccino','chestnut','kastanje']],
          ['Grå', ['grå','gray','grey','charcoal','koks','graphite','grafitt','platinum','platina','silver','sølv','ash','aske','slate','smoke','røyk','steel','stål','anthracite','antrasitt']],
          ['Sort', ['sort','svart','black','onyx','coal','ink','blekk']],
          ['Blå', ['blå','blue','navy','marine','denim','indigo','petrol','teal','sky','himmel','jeans','royal','azure']],
          ['Grønn', ['grønn','green','sage','salvie','forest','skog','olive','oliven','moss','mose','emerald','smaragd','bottle','flaske','mint']],
          ['Rød', ['rød','red','wine','vin','burgundy','bordeaux','ruby','rubin','cherry','kirseb']],
          ['Oransje', ['oransje','orange','terracotta','terrakotta','clay','leire','rust','amber','rav','apricot','aprikos','brick','tegl']],
          ['Gul', ['gul','yellow','mustard','sennep','ochre','oker','gold','gull','honey','honning','curry']],
          ['Rosa', ['rosa','pink','rose','blush','powder','pudder','salmon','laks']]
        ];
        function familyOf(name) {
          var n = (name || '').toLowerCase();
          var parts = n.split(/[—–-]/);
          var tail = parts.length > 1 ? parts[parts.length - 1] : n;
          for (var i = 0; i < FAM.length; i++) for (var k = 0; k < FAM[i][1].length; k++) {
            var kw = FAM[i][1][k]; if (tail.indexOf(kw) > -1 || n.indexOf(kw) > -1) return FAM[i][0];
          }
          return 'Beige';
        }
        function material(name) { return (name || '').split(' ')[0] || 'Annet'; }

        var selected = fabrics[0].name;
        function swatch(f) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'm-swatch';
          b.setAttribute('data-fabric', ''); b.setAttribute('data-fabric-name', f.name);
          if (f.add && f.add > 0) b.setAttribute('data-fabric-add', f.add);
          b.title = f.name; b.setAttribute('aria-label', f.name);
          var sp = document.createElement('span'); sp.className = 'm-swatch__chip'; sp.style.background = f.hex || '#ccc';
          b.appendChild(sp);
          b.addEventListener('click', function () { select(f.name, true); });
          return b;
        }
        function pickFeatured() {
          var out = [], seen = {};
          function add(f) { if (f && !seen[f.name]) { seen[f.name] = 1; out.push(f); } }
          add(fabrics.filter(function (f) { return f.name === selected; })[0] || fabrics[0]); // always show the chosen one
          trend.forEach(function (fam) { if (out.length < 5) add(fabrics.filter(function (f) { return !seen[f.name] && familyOf(f.name) === fam; })[0]); });
          fabrics.forEach(function (f) { if (out.length < 5) add(f); });
          return out.slice(0, 5);
        }
        function markSelected(scope) {
          (scope || root).querySelectorAll('[data-fabric]').forEach(function (b) {
            var on = b.getAttribute('data-fabric-name') === selected;
            b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }
        function renderFeatured() {
          featuredWrap.innerHTML = '';
          pickFeatured().forEach(function (f) { featuredWrap.appendChild(swatch(f)); });
          markSelected(featuredWrap);
        }
        function select(name, close) {
          selected = name;
          if (fabricProp) fabricProp.value = name;
          if (fabricName) fabricName.textContent = name;
          renderFeatured();
          markSelected();
          if (close && drawer && !drawer.hidden) closeDrawer();
        }

        // ---- drawer (Layer 3): all colours grouped by material + family chips ----
        var activeFam = '';
        function renderGroups() {
          if (!groupsWrap) return;
          groupsWrap.innerHTML = '';
          var mats = [];
          fabrics.forEach(function (f) { var m = material(f.name); if (mats.indexOf(m) < 0) mats.push(m); });
          mats.forEach(function (m) {
            var inMat = fabrics.filter(function (f) { return material(f.name) === m && (!activeFam || familyOf(f.name) === activeFam); });
            if (!inMat.length) return;
            var g = document.createElement('div'); g.className = 'm-fabdrawer__group';
            var lbl = document.createElement('div'); lbl.className = 'm-fabdrawer__group-label'; lbl.textContent = m;
            var rowEl = document.createElement('div'); rowEl.className = 'm-swatches__row';
            inMat.forEach(function (f) { rowEl.appendChild(swatch(f)); });
            g.appendChild(lbl); g.appendChild(rowEl); groupsWrap.appendChild(g);
          });
          markSelected(groupsWrap);
        }
        function renderChips() {
          if (!chipsWrap) return;
          var fams = [];
          fabrics.forEach(function (f) { var x = familyOf(f.name); if (fams.indexOf(x) < 0) fams.push(x); });
          chipsWrap.innerHTML = '';
          function chip(label, val) {
            var c = document.createElement('button'); c.type = 'button';
            c.className = 'm-fabchip' + (activeFam === val ? ' is-on' : ''); c.textContent = label;
            c.addEventListener('click', function () { activeFam = val; renderChips(); renderGroups(); });
            return c;
          }
          chipsWrap.appendChild(chip('Alle', ''));
          fams.forEach(function (fam) { chipsWrap.appendChild(chip(fam, fam)); });
        }
        function openDrawer() { if (!drawer) return; renderChips(); renderGroups(); drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); document.documentElement.style.overflow = 'hidden'; }
        function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 320); }

        // ---- wire up (progressive enhancement: hide no-JS fallback, show featured) ----
        if (fallback) fallback.hidden = true;
        featuredWrap.hidden = false;
        renderFeatured();
        if (fabrics.length > 5 && allBtn) {
          if (countEl) countEl.textContent = fabrics.length;
          allBtn.hidden = false;
          allBtn.addEventListener('click', openDrawer);
        }
        if (drawer) {
          drawer.querySelectorAll('[data-fab-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
          document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer(); });
        }
      })();

      // ----- Quantity stepper -----
      var qty = root.querySelector('[data-qty-input]');
      var minus = root.querySelector('[data-qty-minus]');
      var plus = root.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

      // ----- Description toggle -----
      var descToggle = root.querySelector('[data-desc-toggle]');
      var desc = root.querySelector('[data-desc]');
      if (descToggle && desc) {
        var descToggleLabel = descToggle.querySelector('[data-desc-toggle-label]') || descToggle;
        var descShort = root.querySelector('[data-desc-short]');
        descToggle.addEventListener('click', function () {
          var willOpen = desc.hidden;
          desc.hidden = !willOpen;
          if (descShort) descShort.hidden = willOpen;
          descToggle.classList.toggle('is-open', willOpen);
          descToggleLabel.textContent = willOpen ? descToggle.getAttribute('data-less') : descToggle.getAttribute('data-more');
        });
      }

      // Wishlist heart is handled globally by mobellia-wishlist.js.

      // ----- Gallery -----
      var gallery = root.querySelector('[data-gallery]');
      if (gallery) {
        var mainImg = gallery.querySelector('[data-gallery-main]');
        var allThumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
        var moreBtn = gallery.querySelector('[data-thumbs-all]');
        var moreN = gallery.querySelector('[data-thumbs-all-n]');
        // `thumbs` = the photos currently offered (selected colour + shared, or all after
        // "Alle bilder"); arrows, swipe and the lightbox cycle through exactly these.
        var thumbs = allThumbs.filter(function (t) { return !t.hidden; });
        var idx = Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }));
        var showAll = false;
        function ladder(full) {
          return [600, 900, 1200, 1600].map(function (w) { return full.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
        }
        function show(i) {
          if (!thumbs.length) return;
          idx = (i + thumbs.length) % thumbs.length;
          var t = thumbs[idx];
          if (mainImg) {
            // srcset first, then src: the srcset is what the browser actually
            // renders, and leaving a stale one pinned the gallery to photo 1.
            var full = t.getAttribute('data-full');
            mainImg.setAttribute('srcset', ladder(full));
            mainImg.src = full;
            var ti = t.querySelector('img');
            if (ti && ti.alt) mainImg.alt = ti.alt;
          }
          allThumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (t.scrollIntoView && t.parentNode && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
            var strip = t.parentNode;
            var left = t.offsetLeft - strip.offsetLeft;
            if (left < strip.scrollLeft || left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left;
          }
        }
        function setVisible(block) {
          var hiddenN = 0;
          allThumbs.forEach(function (t) {
            var b = t.getAttribute('data-block');
            var vis = showAll || block == null || b === '0' || b === String(block);
            t.hidden = !vis;
            if (!vis) hiddenN++;
          });
          thumbs = allThumbs.filter(function (t) { return !t.hidden; });
          if (moreBtn) { moreBtn.hidden = hiddenN === 0; if (moreN) moreN.textContent = '+' + hiddenN; }
        }
        var hasBlocks = allThumbs.some(function (t) { return t.getAttribute('data-block') !== '0'; });
        galleryApi = {
          showVariant: function (v) {
            var fm = v && v.featured_media;
            if (!fm || fm.id == null) return;          // variant has no own photo: keep the current one
            var target = allThumbs.filter(function (t) { return t.getAttribute('data-media-id') === String(fm.id); })[0];
            if (!target) return;
            if (hasBlocks) {
              var b = target.getAttribute('data-block');
              setVisible(b === '0' ? null : b);
            }
            var i = thumbs.indexOf(target);
            if (i < 0) { showAll = true; setVisible(null); i = thumbs.indexOf(target); }
            show(i);
          }
        };
        if (moreBtn) moreBtn.addEventListener('click', function () {
          var cur = thumbs[idx];
          showAll = true; setVisible(null);
          moreBtn.hidden = true;
          idx = Math.max(0, thumbs.indexOf(cur));
        });
        allThumbs.forEach(function (t) { t.addEventListener('click', function () { var i = thumbs.indexOf(t); if (i > -1) show(i); }); });
        (function () {
          var strip = gallery.querySelector('[data-thumbs]');
          var prevB = gallery.querySelector('[data-thumb-prev]');
          var nextB = gallery.querySelector('[data-thumb-next]');
          if (!strip || !prevB || !nextB) return;
          function sync() {
            var max = strip.scrollWidth - strip.clientWidth;
            prevB.hidden = !(max > 2 && strip.scrollLeft > 2);
            nextB.hidden = !(max > 2 && strip.scrollLeft < max - 2);
          }
          prevB.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth * 0.8 }); });
          nextB.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.8 }); });
          strip.addEventListener('scroll', sync, { passive: true });
          window.addEventListener('resize', sync);
          if (window.MutationObserver) new MutationObserver(sync).observe(strip, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
          sync();
        })();
        var gp = gallery.querySelector('[data-gallery-prev]');
        var gn = gallery.querySelector('[data-gallery-next]');
        if (gp) gp.addEventListener('click', function () { show(idx - 1); });
        if (gn) gn.addEventListener('click', function () { show(idx + 1); });

        // ----- Touch swipe on the main image (mobile) -----
        // Swipe left -> next, right -> prev, with wrap. A real swipe suppresses the
        // tap-to-zoom that would otherwise fire on touchend.
        var main = gallery.querySelector('.m-gallery__main');
        if (main && allThumbs.length > 1) {
          var sx = 0, sy = 0, swiping = false, moved = false;
          main.addEventListener('touchstart', function (e) {
            if (e.touches.length !== 1) { swiping = false; return; }
            sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true; moved = false;
          }, { passive: true });
          main.addEventListener('touchmove', function (e) {
            if (!swiping) return;
            var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
            if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) moved = true;
          }, { passive: true });
          main.addEventListener('touchend', function (e) {
            if (!swiping) return; swiping = false;
            var dx = (e.changedTouches[0] ? e.changedTouches[0].clientX : sx) - sx;
            if (Math.abs(dx) >= 40) { show(dx < 0 ? idx + 1 : idx - 1); }
          }, { passive: true });
          // Block the zoom-open click when the gesture was a swipe, not a tap.
          main.addEventListener('click', function (e) {
            if (moved) { e.preventDefault(); e.stopImmediatePropagation(); moved = false; }
          }, true);
        }

        // ----- Tap-to-zoom lightbox -----
        var zoom = gallery.querySelector('[data-zoom]');
        var zoomImg = gallery.querySelector('[data-zoom-img]');
        var opener = gallery.querySelector('[data-zoom-open]');
        if (zoom && zoomImg && opener) {
          // Lightbox mirrors the gallery's current image (same show()/idx — no
          // separate index). syncZoom() re-reads the active thumb at high res.
          function syncZoom() {
            var t = thumbs[idx];
            var full = (t && t.getAttribute('data-full')) || (mainImg && (mainImg.currentSrc || mainImg.src)) || '';
            zoomImg.src = full.replace(/width=\d+/, 'width=1800');
            zoom.classList.remove('is-zoomed');
          }
          function openZoom() { syncZoom(); zoom.hidden = false; document.documentElement.style.overflow = 'hidden'; }
          function closeZoom() { zoom.hidden = true; zoom.classList.remove('is-zoomed'); document.documentElement.style.overflow = ''; }
          function step(d) { show(idx + d); syncZoom(); }   // advances the shared idx + main image too
          opener.addEventListener('click', openZoom);
          zoomImg.addEventListener('click', function (e) { e.stopPropagation(); zoom.classList.toggle('is-zoomed'); });
          zoom.addEventListener('click', closeZoom);
          var zp = gallery.querySelector('[data-zoom-prev]');
          var zn = gallery.querySelector('[data-zoom-next]');
          if (zp) zp.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
          if (zn) zn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
          var zc = gallery.querySelector('[data-zoom-close]');
          if (zc) zc.addEventListener('click', function (e) { e.stopPropagation(); closeZoom(); });

          // Swipe inside the lightbox (mobile). Only while not zoomed in — once
          // .is-zoomed is on, a horizontal drag is the customer panning the photo.
          if (allThumbs.length > 1) {
            var zx = 0, zy = 0, zswipe = false;
            zoom.addEventListener('touchstart', function (e) {
              if (e.touches.length !== 1 || zoom.classList.contains('is-zoomed')) { zswipe = false; return; }
              zx = e.touches[0].clientX; zy = e.touches[0].clientY; zswipe = true;
            }, { passive: true });
            zoom.addEventListener('touchend', function (e) {
              if (!zswipe) return; zswipe = false;
              var t0 = e.changedTouches[0]; if (!t0) return;
              var dx = t0.clientX - zx, dy = t0.clientY - zy;
              if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
                e.preventDefault();          // a swipe must not also close the lightbox
                step(dx < 0 ? 1 : -1);
              }
            });
          }
          document.addEventListener('keydown', function (e) {
            if (zoom.hidden) return;
            if (e.key === 'Escape') closeZoom();
            else if (e.key === 'ArrowLeft') step(-1);
            else if (e.key === 'ArrowRight') step(1);
          });
        }
      }

      update();
    }
    function init() { document.querySelectorAll('[data-pdp]').forEach(initPdp); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-page"]) return;
  try {
    
  (function () {
    // Klaviyo client-side subscribe (double opt-in). Inert until the owner adds
    // the Public API key + list id on the section; the Shopify form is the live
    // fallback in the meantime.
    function init(wrap) {
      if (!wrap || wrap.dataset.ready) return;
      if (wrap.getAttribute('data-klaviyo-ready') !== 'true') return;
      wrap.dataset.ready = '1';
      var company = wrap.getAttribute('data-klaviyo-public-key');
      var listId = wrap.getAttribute('data-klaviyo-list-id');
      var form = wrap.querySelector('[data-news-form]');
      var status = wrap.querySelector('[data-news-status]');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('input[type="email"]');
        var email = emailInput && emailInput.value;
        if (!email) return;
        if (status) { status.hidden = false; status.className = 'm-news__status'; status.textContent = 'Sender …'; }
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email } } },
                custom_source: 'Nyhetsbrev-side'
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        }).then(function (r) {
          if (status) {
            if (r.ok || r.status === 202) { status.className = 'm-news__status is-ok'; status.textContent = 'Takk! Sjekk innboksen for å bekrefte påmeldingen.'; form.reset(); }
            else { status.className = 'm-news__status is-err'; status.textContent = 'Noe gikk galt. Prøv igjen senere.'; }
          }
        }).catch(function () {
          if (status) { status.className = 'm-news__status is-err'; status.textContent = 'Noe gikk galt. Prøv igjen senere.'; }
        });
      });
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-klaviyo-form]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-status"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('[data-order-status]').forEach(function (root) {
        if (root.dataset.osReady) return; root.dataset.osReady = '1';
        var endpoint = root.getAttribute('data-endpoint');
        var form = root.querySelector('[data-os-form]');
        var out = root.querySelector('[data-os-result]');
        if (!endpoint || !form || !out) return;
        var btn = form.querySelector('[data-os-submit]');

        function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
        function fmtDate(iso) { try { return new Date(iso).toLocaleDateString('nb-NO', { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { return ''; } }
        function show(html) { out.innerHTML = html; out.hidden = false; }

        function render(d) {
          if (!d || d.found === false) {
            show('<div class="m-ostat__card m-ostat__card--miss"><p class="m-ostat__err">' +
              esc((d && d.message) || 'Fant ingen bestilling.') + '</p></div>');
            return;
          }
          var track = '';
          if (d.tracking && d.tracking.length) {
            track = '<ul class="m-ostat__track">' + d.tracking.map(function (t) {
              var label = (t.company ? esc(t.company) + ' — ' : '') + (t.number ? esc(t.number) : 'Sporing');
              return t.url ? '<li><a href="' + esc(t.url) + '" target="_blank" rel="noopener noreferrer">' + label + '</a></li>'
                           : '<li>' + label + '</li>';
            }).join('') + '</ul>';
          }
          var placed = d.placedAt ? '<p class="m-ostat__order">Bestilt ' + esc(fmtDate(d.placedAt)) + '</p>' : '';
          show('<div class="m-ostat__card">' +
            '<p class="m-ostat__order">Ordre ' + esc(d.orderName || '') + '</p>' +
            '<div class="m-ostat__badge"><span class="m-ostat__dot m-ostat__dot--' + esc(d.status || '') + '"></span>' + esc(d.statusLabel || '') + '</div>' +
            '<p class="m-ostat__note">' + esc(d.statusNote || '') + '</p>' + track + placed + '</div>');
        }

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var order = form.order.value.trim();
          var email = form.email.value.trim();
          if (!order || !email) { show('<div class="m-ostat__card m-ostat__card--miss"><p class="m-ostat__err">Fyll inn både ordrenummer og e-post.</p></div>'); return; }
          var orig = btn.textContent;
          btn.disabled = true; btn.textContent = 'Henter …';
          fetch(endpoint, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ order: order, email: email }),
          })
            .then(function (r) { return r.json().catch(function () { return null; }); })
            .then(function (d) { render(d); })
            .catch(function () { show('<div class="m-ostat__card m-ostat__card--miss"><p class="m-ostat__err">Kunne ikke hente status akkurat nå. Prøv igjen senere.</p></div>'); })
            .then(function () { btn.disabled = false; btn.textContent = orig; });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"]) return;
  try {
    
  (function () {
    function initAccordion(root) {
      if (root.dataset.accReady) return;
      root.dataset.accReady = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-acc-item]'));
      items.forEach(function (item) {
        var trigger = item.querySelector('[data-acc-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var t = other.querySelector('[data-acc-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) { item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
        });
      });
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-mobellia-accordion]').forEach(initAccordion); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'mobellia:recently-viewed';

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
    }
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
    function money(cents) {
      var n = Math.round((cents || 0) / 100);
      return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
    }
    function imgUrl(u) {
      if (!u) return '';
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=540';
    }
    function card(p) {
      var media = p.featured_image ? '<img src="' + imgUrl(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
      var price = (p.compare_at_price && p.compare_at_price > p.price)
        ? '<span class="m-price"><span class="m-price__compare">' + money(p.compare_at_price) + '</span><span class="m-price__current m-price__current--sale">' + money(p.price) + '</span></span>'
        : '<span class="m-price"><span class="m-price__current">' + money(p.price) + '</span></span>';
      return '<div class="m-card"><a href="' + p.url + '" class="m-card__link" aria-label="' + esc(p.title) + '">' +
        '<div class="m-card__media"><div class="m-card__zoom">' + media + '</div></div>' +
        '<div class="m-card__cat">' + esc(p.type || '') + '</div>' +
        '<div class="m-card__name">' + esc(p.title) + '</div>' +
        '<div class="m-card__price">' + price + '</div></a></div>';
    }

    function init(scope) {
      var sec = (scope || document).querySelector('[data-recently-viewed]');
      if (!sec || sec.dataset.ready) return;
      sec.dataset.ready = '1';
      var current = sec.getAttribute('data-current');
      var limit = parseInt(sec.getAttribute('data-limit'), 10) || 4;
      var grid = sec.querySelector('[data-rv-grid]');

      // Record current product, then read the rest of the history.
      var list = read().filter(function (h) { return h && h !== current; });
      var toShow = list.slice(0, limit);
      if (current) write([current].concat(list));

      if (!toShow.length) return; // no history yet → stay hidden

      Promise.all(toShow.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (items) {
        var html = items.filter(Boolean).map(card).join('');
        if (html) { grid.innerHTML = html; sec.hidden = false; }
      });
    }

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-upsell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindAdd(scope) {
      (scope || document).querySelectorAll('[data-upsell-add]').forEach(function (btn) {
        if (btn.dataset.ready) return;
        btn.dataset.ready = 'true';
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-added') || btn.disabled) return;
          var id = btn.getAttribute('data-variant-id');
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          }).then(function (r) {
            btn.disabled = false;
            if (r.ok) {
              btn.classList.add('is-added');
              btn.textContent = btn.getAttribute('data-label-added');
              document.dispatchEvent(new CustomEvent('mobellia:cart:added'));
            }
          }).catch(function () { btn.disabled = false; });
        });
      });
    }

    function loadRecos(scope) {
      (scope || document).querySelectorAll('[data-upsell-reco]').forEach(function (el) {
        if (el.dataset.loading) return;
        el.dataset.loading = '1';
        // Complementary first, related second. Each response is rendered by this
        // section, so the heading always matches the intent that produced it.
        var urls = [el.getAttribute('data-url'), el.getAttribute('data-url-fallback')].filter(Boolean);
        (function attempt(i) {
          if (i >= urls.length) { el.remove(); return; } // nothing to show
          fetch(urls[i]).then(function (r) { return r.text(); }).then(function (html) {
            var section = new DOMParser().parseFromString(html, 'text/html').querySelector('.m-upsell');
            if (section) {
              el.replaceWith(section);
              bindAdd(section);
            } else {
              attempt(i + 1);
            }
          }).catch(function () { attempt(i + 1); });
        })(0);
      });
    }

    function init(scope) { bindAdd(scope); loadRecos(scope); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(scope) {
      (scope || document).querySelectorAll('[data-reviews]').forEach(function (wrap) {
        if (wrap.dataset.rvReady) return;
        var track = wrap.querySelector('[data-reviews-track]');
        if (!track) return;
        wrap.dataset.rvReady = '1';
        var prev = wrap.querySelector('[data-reviews-prev]');
        var next = wrap.querySelector('[data-reviews-next]');
        function update() {
          if (prev) prev.disabled = track.scrollLeft <= 4;
          if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        }
        function page(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' }); }
        if (prev) prev.addEventListener('click', function () { page(-1); });
        if (next) next.addEventListener('click', function () { page(1); });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initReviews(); }); } else { initReviews(); }
    document.addEventListener('shopify:section:load', function (e) { initReviews(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
